export default __webpack_public_path__ + "static/media/4g.cd7771b3.svg";